import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as prechargeOrderApi from '../../api/prechargeOrder';
import { message } from 'antd';

// 获取预充值订单列表
export const fetchPrechargeOrders = createAsyncThunk(
  'prechargeOrder/fetchPrechargeOrders',
  async (params, { rejectWithValue }) => {
    try {
      console.log(params);
      const response = await prechargeOrderApi.getPrechargeOrderList(params);
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取预充值订单列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取预充值订单列表失败');
    }
  }
);

// 审核预充值订单
export const auditPrechargeOrder = createAsyncThunk(
  'prechargeOrder/auditPrechargeOrder',
  async ({ id, status, remark }, { rejectWithValue }) => {
    try {
      const response = await prechargeOrderApi.auditPrechargeOrder(id, { status, remark });
      if (response && response.code === 200) {
        message.success('审核预充值订单成功');
        return response.data;
      }
      message.error(response?.message || '审核预充值订单失败');
      return rejectWithValue(response?.message || '审核预充值订单失败');
    } catch (error) {
      message.error(error.message || '审核预充值订单失败');
      return rejectWithValue(error.message || '审核预充值订单失败');
    }
  }
);

// 初始状态
const initialState = {
  prechargeOrderList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    error: null,
    searchParams: {
      userId: undefined,
      orderNo: '',
      orderStatus: undefined,
      paymentMethod: undefined,
      minAmount: undefined,
      maxAmount: undefined,
      username: '',
      nickname: '',
      startTime: undefined,
      endTime: undefined
    }
  },
  auditStatus: {
    loading: false,
    success: false,
    error: null
  }
};

// 创建slice
const prechargeOrderSlice = createSlice({
  name: 'prechargeOrder',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.prechargeOrderList.searchParams = {
        ...state.prechargeOrderList.searchParams,
        ...action.payload
      };
    },
    resetSearchParams: (state) => {
      state.prechargeOrderList.searchParams = {
        userId: undefined,
        orderNo: '',
        orderStatus: undefined,
        paymentMethod: undefined,
        minAmount: undefined,
        maxAmount: undefined,
        username: '',
        nickname: '',
        startTime: undefined,
        endTime: undefined
      };
    },
    clearAuditStatus: (state) => {
      state.auditStatus = {
        loading: false,
        success: false,
        error: null
      };
    }
  },
  extraReducers: (builder) => {
    builder
      // 处理获取预充值订单列表
      .addCase(fetchPrechargeOrders.pending, (state) => {
        state.prechargeOrderList.loading = true;
        state.prechargeOrderList.error = null;
      })
      .addCase(fetchPrechargeOrders.fulfilled, (state, action) => {
        state.prechargeOrderList.loading = false;
        state.prechargeOrderList.data = action.payload.data.records || [];
        state.prechargeOrderList.total = action.payload.data.total || 0;
        
        // 使用传入的page和size参数更新状态，而不是依赖后端返回的值
        if (action.payload.params) {
          if (action.payload.params.page) {
            state.prechargeOrderList.current = action.payload.params.page;
          } else {
            state.prechargeOrderList.current = action.payload.data.current || 1;
          }
          
          if (action.payload.params.size) {
            state.prechargeOrderList.size = action.payload.params.size;
          } else {
            state.prechargeOrderList.size = action.payload.data.size || 10;
          }
        } else {
          state.prechargeOrderList.current = action.payload.data.current || 1;
          state.prechargeOrderList.size = action.payload.data.size || 10;
        }
        
        // 检查是否有明确传入的搜索参数，如果有则更新searchParams
        if (action.payload.params) {
          // 过滤掉page和size参数，避免将它们保存到searchParams中
          const { page, size, ...searchParams } = action.payload.params;
          
          // 如果没有传入特定的搜索参数，则不要覆盖现有的searchParams
          const hasSearchParams = Object.values(searchParams).some(value => 
            value !== undefined && value !== '' && value !== null
          );
          
          // 只有在有明确的搜索参数时才更新
          if (hasSearchParams) {
            state.prechargeOrderList.searchParams = {
              ...state.prechargeOrderList.searchParams,
              ...searchParams
            };
          }
        }
      })
      .addCase(fetchPrechargeOrders.rejected, (state, action) => {
        state.prechargeOrderList.loading = false;
        state.prechargeOrderList.error = action.payload;
      })

      // 处理审核预充值订单
      .addCase(auditPrechargeOrder.pending, (state) => {
        state.auditStatus.loading = true;
        state.auditStatus.success = false;
        state.auditStatus.error = null;
      })
      .addCase(auditPrechargeOrder.fulfilled, (state) => {
        state.auditStatus.loading = false;
        state.auditStatus.success = true;
      })
      .addCase(auditPrechargeOrder.rejected, (state, action) => {
        state.auditStatus.loading = false;
        state.auditStatus.error = action.payload;
      });
  }
});

export const { setSearchParams, resetSearchParams, clearAuditStatus } = prechargeOrderSlice.actions;

export default prechargeOrderSlice.reducer; 